import { http } from '../http'
import { URL } from './_constant'

/**
 * 原始档案-征拆户-列表
 */
export function API_ORIGIN_ARCHIVE_ZCH_LIST(data?: BasicPageReq) {
  return http.post<ApiOriginArchiveZch.ListRes>(URL.LIST, data)
}

/**
 * 原始档案-征拆户-全部
 */
export function API_ORIGIN_ARCHIVE_ZCH_ALL(data?: BasicPageReq) {
  return http.post<ApiOriginArchiveZch.Item[]>(URL.LIST, data)
}

/**
 * 原始档案-征拆户-详情
 */
export function API_ORIGIN_ARCHIVE_ZCH_DETAIL(id: string) {
  return http.post<ApiOriginArchiveZch.Item>(URL.DETAIL, { id })
}

/**
 * 原始档案-征拆户-新增
 */
export function API_ORIGIN_ARCHIVE_ZCH_ADD(data: ApiOriginArchiveZch.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 原始档案-征拆户-删除
 */
export function API_ORIGIN_ARCHIVE_ZCH_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  原始档案-征拆户-编辑
 */
export function API_ORIGIN_ARCHIVE_ZCH_EDIT(data: BasicUpdateOneReq<ApiOriginArchiveZch.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  原始档案-征拆户-禁用
 */
export function API_ORIGIN_ARCHIVE_ZCH_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 原始档案-征拆户-启用
 */
export function API_ORIGIN_ARCHIVE_ZCH_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 原始档案-征拆户-排序
 */
export function API_ORIGIN_ARCHIVE_ZCH_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 原始档案-征拆户-导出
 */
export function API_ORIGIN_ARCHIVE_ZCH_EXPORT(data: BasicExportReq) {
  return http.post(URL.EXPORT, data)
}
